import {
	ResourcePlanningTimeOffDocument,
	type ResourcePlanningTimeOffQuery,
	type User,
} from '@/generated/graphql';
import { dateToMysqlString } from '@/composables/settings/useFormatter/formatterUtils';
import { useApolloClient } from '@vue/apollo-composable';
import { usePermissions } from '@/composables';
import { Feature } from '@/constants/features';
import { type ResourcePlanningPortfolioConfig } from '../../components/ResourcePlanningPortfolio/ResourcePlanningPortfolioConfig';
import { type ResourcePlanningGanttConfig } from '../../components/ResourcePlanningGantt/ResourcePlanningGanttConfig';

export const useResourcePlanningTimeOff = (
	config: ResourcePlanningPortfolioConfig | ResourcePlanningGanttConfig
) => {
	const { client } = useApolloClient();
	const { userHas } = usePermissions();

	const handleTimeOffResponse = ({
		UserTimeOffList,
	}: ResourcePlanningTimeOffQuery) => {
		UserTimeOffList?.forEach((row) => {
			config.setTimeOffData(row);
		});

		config.gantt.render();
	};

	const loadTimeOffData = (
		userIds: Array<User['id']>,
		startDate: Date,
		endDate: Date
	) => {
		if (!userHas(Feature.TIMEOFF)) {
			return;
		}

		client
			.query({
				query: ResourcePlanningTimeOffDocument,
				variables: {
					input: {
						filters: {
							userIds,
							startDate: dateToMysqlString(startDate),
							endDate: dateToMysqlString(endDate),
						},
					},
				},
				fetchPolicy: 'no-cache',
			})
			.then((response: { data: ResourcePlanningTimeOffQuery }) => {
				handleTimeOffResponse(response.data);
			});
	};

	return {
		loadTimeOffData,
	};
};
